import path from 'path';
import {Plugins} from '@packages/systems/wfdl';
import type {
  Interaction,
  Timeline,
  TimelineId,
} from '@packages/systems/ix3/core';

export * from './types';

export const plugin = Plugins.PrivilegedPlugin({
  siteModules: [
    {
      filePaths: [path.resolve(__dirname, 'webflow-ix3.js')],
      bundleIf: {
        type: 'page',
        test: (page, siteJson) => {
          const pageId = page?._id?.toString();
          const pageInteractions = siteJson?.ix3Interactions?.[pageId] || [];
          const siteInteractions = siteJson?.ix3Interactions?.site || [];
          const interactions: Interaction[] =
            siteInteractions.concat(pageInteractions);

          if (interactions.length === 0) {
            return false;
          }

          const timelines: Timeline[] = siteJson?.ix3Timelines ?? [];
          const timelinesMap = timelines.reduce(
            (acc, timeline) => {
              acc[timeline.id] = timeline.actions;
              return acc;
            },
            {} as Record<TimelineId, Timeline['actions']>
          );

          for (const {timelineIds} of interactions) {
            for (const timelineId of timelineIds) {
              const timelineActions = timelinesMap[timelineId];
              if (timelineActions?.length) return true;
            }
          }

          return false;
        },
      },
    },
  ],
});
